import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Danh mục giá (PriceSetupScreen.tsx). Mã phí, hãng, cảng, tên VN/EN của phí, tầng margin (setup.ts) và dữ liệu mẫu không dịch.
addMessages('vi', {
  'ps.tLcc': 'Local charge hãng',
  'ps.tHub': 'Cảng chuyển tải',
  'ps.tTariff': 'Biểu giá dịch vụ',
  'ps.tCus': 'Phụ phí riêng khách',
  'ps.tRoe': 'Tỷ giá VCB',
  'ps.tCtry': 'Cảng & quốc gia',
  'ps.tMargin': 'Margin theo tuyến',
  'ps.aLcc': 'Thêm local charge',
  'ps.aHub': 'Thêm cảng chuyển tải',
  'ps.aTariff': 'Thêm mã phí',
  'ps.aCus': 'Đặt giá riêng',
  'ps.aRoe': 'Lấy tỷ giá ngay',
  'ps.aCtry': 'Thêm cảng',
  'ps.aMargin': 'Đề nghị margin',
  'ps.actions': 'Thao tác',
  'ps.approve': 'Duyệt',
  'ps.reject': 'Từ chối',
  'ps.cancel': 'Huỷ',
  'ps.mEdit': 'Đề nghị sửa',
  'ps.mWaiting': 'Đang chờ',
  'ps.mEditTip': 'Đề nghị đổi margin · cần người khác duyệt',
  'ps.mHasPend': 'Đã có đề nghị chờ duyệt',
  'ps.mTitle': 'Đề nghị đổi margin',
  'ps.mNow': 'hiện {a} / {b} USD',
  'ps.mNewTier': 'Tầng mới',
  'ps.mApprover': 'Người duyệt',
  'ps.mWhy': 'Lý do *',
  'ps.mWhyPh': 'Vd: hãng tăng GRI, giữ khách lớn…',
  'ps.mWhyNeed': 'Cần nhập lý do',
  'ps.mSend': 'Gửi đề nghị',
  'ps.mSent': 'Đã gửi đề nghị · chờ [SAL-MGR] DAVID duyệt (chưa bật ghi)',
  'ps.mApproved': 'Đã duyệt margin · {v}',
  'ps.mRejected': 'Đã từ chối đề nghị · {v}',
  'ps.noWrite': 'Chưa bật ghi danh mục giá',
  'ps.find': 'Tìm',
  'ps.carrier': 'Hãng',
  'ps.side': 'Phía',
  'ps.code': 'Mã',
  'ps.name': 'Tên',
  'ps.unitTerm': 'Đơn vị · Term',
  'ps.type': 'Loại',
  'ps.valid': 'Hiệu lực',
  'ps.fromV': 'từ {v}',
  'ps.edit': 'Sửa',
  'ps.delAria': 'Xoá {v}',
  'ps.del': 'Xoá',
  'ps.lccPh': 'Tìm mã phí, hãng, LocalChargeCode',
  'ps.buyHidden': 'Giá mua ẩn.',
  'ps.sideCar': 'Phía và hãng',
  'ps.all': 'Tất cả',
  'ps.paste': 'Dán bảng Excel',
  'ps.history': 'Lịch sử',
  'ps.podApply': 'POD áp dụng',
  'ps.transit2': 'Transit chặng 2',
  'ps.status': 'Trạng thái',
  'ps.inUse': 'Đang dùng',
  'ps.paused': 'Tạm ngưng',
  'ps.days': '{n} ngày',
  'ps.nameVnEn': 'Tên VN / EN',
  'ps.group': 'Nhóm',
  'ps.unit': 'Đơn vị',
  'ps.defaultJob': 'Mặc định vào job',
  'ps.default': 'Mặc định',
  'ps.cusPrice': 'Khách có giá riêng',
  'ps.customer': 'Khách',
  'ps.content': 'Nội dung',
  'ps.source': 'Nguồn',
  'ps.day': 'Ngày',
  'ps.currency': 'Tiền tệ',
  'ps.sell': 'Bán (VCB)',
  'ps.buyTransfer': 'Mua CK (VCB)',
  'ps.convert': 'Hana quy đổi',
  'ps.askHana': 'Hỏi Hana',
  'ps.askPh': 'Ví dụ: 1.500 usd',
  'ps.noUnderstand': 'Chưa hiểu — nhập số tiền và tiền tệ (usd, eur, vnd).',
  'ps.perVcb': 'Theo VCB {v} · cột bán',
  'ps.country': 'Quốc gia',
  'ps.region': 'Vùng',
  'ps.continent': 'Châu lục',
  'ps.mainPorts': 'Cảng chính',
  'ps.tier': 'Tầng',
  'ps.object': 'Đối tượng',
  'ps.floor': 'Sàn',
  'ps.validFrom': 'Hiệu lực từ',
  'ps.editedBy': 'sửa bởi {v}',
  'ps.pending': 'Chờ duyệt',
  'ps.applied': 'Đang áp dụng',
  'ps.orderTip': 'Giá mua nhập ở Freight Cost; margin ở đây cộng vào khi báo giá. Đổi margin cần người khác duyệt.',
  'ps.order': 'Thứ tự áp dụng',
  'ps.pendingChanges': 'Thay đổi chờ duyệt',
  'ps.fourEyes': 'Chờ duyệt · bốn mắt',
  'ps.fourEyesSub': 'Pricing đề nghị → người khác duyệt.',
  'ps.noRequests': 'Không có đề nghị nào đang chờ.',
  'ps.marginNoperm': 'Margin theo tuyến cần quyền xem giá',
  'ps.marginNopermD': 'Xin quyền tiền ở Cài đặt.',
  'ps.title': 'Danh mục giá',
  'ps.section': 'Mục',
  'ps.more': 'Thêm',
  'ps.moreSections': 'Mục khác',
  'ps.moreActions': 'Thao tác khác',
  'ps.nopermT': 'Chỉ xem',
  'ps.errT': 'Không tải được danh mục',
  'ps.nopermD': 'Sửa danh mục giá chỉ Pricing và quản lý làm được.',
  'ps.errD': 'Thử lại sau ít phút.',
  'ps.retry': 'Thử lại',
});
addMessages('en', {
  'ps.tLcc': 'Carrier local charges',
  'ps.tHub': 'Transshipment ports',
  'ps.tTariff': 'Service tariff',
  'ps.tCus': 'Customer-specific surcharges',
  'ps.tRoe': 'VCB exchange rates',
  'ps.tCtry': 'Ports & countries',
  'ps.tMargin': 'Margin by lane',
  'ps.aLcc': 'Add local charge',
  'ps.aHub': 'Add transshipment port',
  'ps.aTariff': 'Add charge code',
  'ps.aCus': 'Set custom price',
  'ps.aRoe': 'Fetch rates now',
  'ps.aCtry': 'Add port',
  'ps.aMargin': 'Propose margin',
  'ps.actions': 'Actions',
  'ps.approve': 'Approve',
  'ps.reject': 'Reject',
  'ps.cancel': 'Cancel',
  'ps.mEdit': 'Propose edit',
  'ps.mWaiting': 'Pending',
  'ps.mEditTip': 'Propose margin change · needs another approver',
  'ps.mHasPend': 'A request is already pending',
  'ps.mTitle': 'Propose margin change',
  'ps.mNow': 'now {a} / {b} USD',
  'ps.mNewTier': 'New tier',
  'ps.mApprover': 'Approver',
  'ps.mWhy': 'Reason *',
  'ps.mWhyPh': 'e.g. carrier GRI, keep key customer…',
  'ps.mWhyNeed': 'Reason required',
  'ps.mSend': 'Send request',
  'ps.mSent': 'Request sent · awaiting [SAL-MGR] DAVID (write not enabled)',
  'ps.mApproved': 'Margin approved · {v}',
  'ps.mRejected': 'Request rejected · {v}',
  'ps.noWrite': 'Writing the price catalogue is not enabled',
  'ps.find': 'Search',
  'ps.carrier': 'Carrier',
  'ps.side': 'Side',
  'ps.code': 'Code',
  'ps.name': 'Name',
  'ps.unitTerm': 'Unit · Term',
  'ps.type': 'Type',
  'ps.valid': 'Validity',
  'ps.fromV': 'from {v}',
  'ps.edit': 'Edit',
  'ps.delAria': 'Delete {v}',
  'ps.del': 'Delete',
  'ps.lccPh': 'Search charge code, carrier, LocalChargeCode',
  'ps.buyHidden': 'Buy rate hidden.',
  'ps.sideCar': 'Side and carrier',
  'ps.all': 'All',
  'ps.paste': 'Paste Excel table',
  'ps.history': 'History',
  'ps.podApply': 'Applies to POD',
  'ps.transit2': 'Leg-2 transit',
  'ps.status': 'Status',
  'ps.inUse': 'In use',
  'ps.paused': 'Paused',
  'ps.days': '{n} days',
  'ps.nameVnEn': 'Name VN / EN',
  'ps.group': 'Group',
  'ps.unit': 'Unit',
  'ps.defaultJob': 'Default on job',
  'ps.default': 'Default',
  'ps.cusPrice': 'Customers with own price',
  'ps.customer': 'Customer',
  'ps.content': 'Content',
  'ps.source': 'Source',
  'ps.day': 'Date',
  'ps.currency': 'Currency',
  'ps.sell': 'Sell (VCB)',
  'ps.buyTransfer': 'Buy transfer (VCB)',
  'ps.convert': 'Hana converts',
  'ps.askHana': 'Ask Hana',
  'ps.askPh': 'Example: 1.500 usd',
  'ps.noUnderstand': 'Not understood — enter an amount and currency (usd, eur, vnd).',
  'ps.perVcb': 'Per VCB {v} · sell column',
  'ps.country': 'Country',
  'ps.region': 'Region',
  'ps.continent': 'Continent',
  'ps.mainPorts': 'Main ports',
  'ps.tier': 'Tier',
  'ps.object': 'Subject',
  'ps.floor': 'Floor',
  'ps.validFrom': 'Effective from',
  'ps.editedBy': 'edited by {v}',
  'ps.pending': 'Pending approval',
  'ps.applied': 'Applied',
  'ps.orderTip': 'Buy rates are entered in Freight Cost; margins here are added when quoting. Changing a margin needs approval from another person.',
  'ps.order': 'Order applied',
  'ps.pendingChanges': 'Changes pending approval',
  'ps.fourEyes': 'Pending · four-eyes',
  'ps.fourEyesSub': 'Pricing proposes → another person approves.',
  'ps.noRequests': 'No requests waiting.',
  'ps.marginNoperm': 'Margin by lane needs rate-viewing permission',
  'ps.marginNopermD': 'Request money permission in Settings.',
  'ps.title': 'Price catalogue',
  'ps.section': 'Section',
  'ps.more': 'More',
  'ps.moreSections': 'More sections',
  'ps.moreActions': 'More actions',
  'ps.nopermT': 'View only',
  'ps.errT': 'Could not load the catalogue',
  'ps.nopermD': 'Only Pricing and managers can edit the price catalogue.',
  'ps.errD': 'Try again in a few minutes.',
  'ps.retry': 'Retry',
});
